import { render } from "./UnitsForm.vue?vue&type=template&id=3e5b3374"
import script from "./UnitsForm.vue?vue&type=script&lang=js"
export * from "./UnitsForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__